import React, { useEffect, useState } from 'react'
import { Button, Card, CardBody, CardFooter, CardText, Col, Row } from 'reactstrap'
import { auth } from "../firebase/firebase-config";
import firebase from "../firebase/firebase-config";
import { useAuthState } from 'react-firebase-hooks/auth';
import SingleUser from '../components/SingleUser/SingleUser';
import { Link } from 'react-router-dom';

const All_Users_beyown = () => {

    const [all_users, setall_users] = useState([])

    // const [search, setsearch] = useState('')
    const [query, setquery] = useState('')


    const get_all_users = async () => {
        await firebase.firestore().collection('users').onSnapshot((users) => {
            const user_data = [];
            users.forEach(element => {
                user_data.push(element.data());
            });
            console.log(user_data);
            setall_users(user_data);

        })

    }
    useEffect(() => {
        get_all_users();
    }, []);

    const search = (data) => {
        return data.filter((user_search) => user_search.username.toLowerCase().includes(query) || user_search.fullName.toLowerCase().includes(query) || user_search.email.toLowerCase().includes(query) || user_search.contact.toLowerCase().includes(query)
            || user_search.loginSource.toLowerCase().includes(query)
        );
    }

    return (
        <>
            <div className="content">
                <Row>
                    <Col xs="12">





                        <div className="row  d-flex justify-content-center align-items-center">

                            <div className="col-md-6">

                                <div className="form" style={{ position: 'relative' }}>
                                    {query == '' ? <i className="fa fa-search" style={{ position: 'absolute', top: '20px', left: '20px', color: '#9ca3af' }}></i> : <i className="fa fa-close" style={{ position: 'absolute', top: '20px', left: '20px', color: '#9ca3af' }}></i>}

                                    <input type="text" className="form-control form-input" placeholder="Search any User..." value={query} onChange={(e) => setquery(e.target.value)} style={{
                                        height: '55px',
                                        textIndent: '33px',
                                        borderRadius: '10px'
                                    }} />
                                    <span className="left-pan" style={{
                                        position: 'absolute',
                                        right: '17px',
                                        top: '13px',
                                        padding: '2px',
                                        borderLeft: '1px solid #d1d5db',
                                    }}>
                                        {query == '' ?
                                            <i className="fa fa-microphone" style={{ paddingLeft: '10px' }}></i> : <i className="fa fa-search" style={{ paddingLeft: '10px' }}></i>}</span>

                                </div>

                            </div>

                        </div>


                    </Col>
                </Row>
                <div className='mt-4'>
                    <div className=" row">
                        {all_users.filter((user_search) => user_search.username.toLowerCase().includes(query) || user_search.fullName.toLowerCase().includes(query) || user_search.email.toLowerCase().includes(query) || user_search.contact.toLowerCase().includes(query)
                            || user_search.loginSource.toLowerCase().includes(query)).map((user, i) => (
                                <SingleUser verificationPage={false} data={user} key={i} />

                            ))}
                    </div>

                </div>


            </div>

        </>
    )
}

export default All_Users_beyown



// {all_users.map((user) => (
//     <div key={user.id} className="container">

//         </div>
// )


// )}